import BlogFortyThreeContainer from "./container/BlogFortyThreeContainer";
export default BlogFortyThreeContainer;
